export default "/_next/static/773be8cb49bac1d004275e94eeeb00a2.png";